import './VisiMap.css'
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import visimapIcon from './Media/VisiMap.png'
import iphone1 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 1.png'
import iphone2 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 2.png'
import iphone3 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 3.png'
import iphone4 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 4.png'
import iphone5 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 5.png'
import iphone6 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 6.png'
import iphone7 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 7.png'
import iphone8 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 8.png'
import iphone9 from './Media/Screenshots/iPhone/Apple iPhone 13 Pro Max Screenshot 9.png'
import ipad1 from './Media/Screenshots/iPad/Apple iPad Pro 12.9 Inch Screenshot 1.png'
import ipad2 from './Media/Screenshots/iPad/Apple iPad Pro 12.9 Inch Screenshot 2.png'
import ipad3 from './Media/Screenshots/iPad/Apple iPad Pro 12.9 Inch Screenshot 3.png'
import ipad4 from './Media/Screenshots/iPad/Apple iPad Pro 12.9 Inch Screenshot 4.png'
import ipad5 from './Media/Screenshots/iPad/Apple iPad Pro 12.9 Inch Screenshot 5.png'
import mac1 from './Media/Screenshots/Mac/Screenshot1.png'
import mac2 from './Media/Screenshots/Mac/Screenshot2.png'
import mac3 from './Media/Screenshots/Mac/Screenshot3.png'
import mac4 from './Media/Screenshots/Mac/Screenshot4.png'
import mac5 from './Media/Screenshots/Mac/Screenshot5.png'
import mac6 from './Media/Screenshots/Mac/Screenshot6.png'
import mac7 from './Media/Screenshots/Mac/Screenshot7.png'
import mac13 from './Media/Screenshots/Mac/Screenshot13.png'
import mac14 from './Media/Screenshots/Mac/Screenshot14.png'
import mac15 from './Media/Screenshots/Mac/Screenshot15.png'

const VisiMap = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [termsContent, setTermsContent] = useState('')
    const [privacyContent, setPrivacyContent] = useState('')
    const [screenshotTab, setScreenshotTab] = useState('iphone')

    // Determine active section from URL
    const getActiveSectionFromPath = () => {
        if (location.pathname === '/visimap/terms-of-use') return 'terms'
        if (location.pathname === '/visimap/privacy-policy') return 'privacy'
        return 'overview'
    }

    const activeSection = getActiveSectionFromPath()

    const handleSectionChange = (section) => {
        if (section === 'overview') {
            navigate('/visimap')
        } else if (section === 'terms') {
            navigate('/visimap/terms-of-use')
        } else if (section === 'privacy') {
            navigate('/visimap/privacy-policy')
        }
    }

    useEffect(() => {
        // Load Terms of Use content
        fetch('/TermsOfUse.html')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const body = doc.body.innerHTML
                setTermsContent(body)
            })
            .catch(error => console.error('Error loading Terms of Use:', error))

        // Load Privacy Policy content
        fetch('/Privacy.html')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const body = doc.body.innerHTML
                setPrivacyContent(body)
            })
            .catch(error => console.error('Error loading Privacy Policy:', error))
    }, [])

    const renderContent = () => {
        switch(activeSection) {
            case 'overview':
                return (
                    <section className="visimap-section">
                        <p>Visualize location data beautifully on iPhone, iPad, and Mac with <strong>VisiMap</strong>. Import a CSV file, connect directly to a live Google Sheet, or enter your locations manually and <strong>VisiMap</strong> handles the rest. It will automatically geocode addresses into coordinates, then build rich, layered maps with fully customizable markers to explore your data spatially.</p>

                        <div className="features-grid">
                            <div className="feature-card">
                                <h4>Interactive Maps</h4>
                                <p>Visualize your location data with beautiful, interactive map displays</p>
                            </div>
                            <div className="feature-card">
                                <h4>iOS & macOS</h4>
                                <p>Beautiful, intuitive interface designed for iPhone, iPad, and Mac</p>
                            </div>
                            <div className="feature-card">
                                <h4>Instant CSV Import</h4>
                                <p>Bring in any data file with address or lat/lng columns</p>
                            </div>
                            <div className="feature-card">
                                <h4>Google Sheets Support</h4>
                                <p>Publish your Google Sheet to web as CSV and connect directly via URL</p>
                            </div>
                            <div className="feature-card">
                                <h4>Manual Data Source</h4>
                                <p>Create a data source by entering location information directly in the app</p>
                            </div>
                            <div className="feature-card">
                                <h4>Smart Geocoding</h4>
                                <p>Automatically converts addresses to map coordinates</p>
                            </div>
                            <div className="feature-card">
                                <h4>Data Layering</h4>
                                <p>Add multiple data sources to build up a rich, layered map view</p>
                            </div>
                            <div className="feature-card">
                                <h4>Custom Markers</h4>
                                <p>Style markers using thousands of icons, colors, and sizes</p>
                            </div>
                            <div className="feature-card">
                                <h4>Map Export</h4>
                                <p>Save your map as an image capturing your current view, all markers, or the entire world map <span className="feature-note">iOS only</span></p>
                            </div>
                            <div className="feature-card">
                                <h4>Location Search</h4>
                                <p>Search for any location directly on the map to quickly navigate to areas of interest</p>
                            </div>
                            <div className="feature-card">
                                <h4>Photo Markers</h4>
                                <p>Location photos are now displayed directly on the map marker</p>
                            </div>
                            <div className="feature-card">
                                <h4>Source Filtering</h4>
                                <p>Temporarily filter data sources while viewing the map without removing them</p>
                            </div>
                        </div>

                        <div className="screenshot-tabs">
                            <span
                                className={screenshotTab === 'iphone' ? 'screenshot-tab active' : 'screenshot-tab'}
                                onClick={() => setScreenshotTab('iphone')}
                            >iPhone</span>
                            <span
                                className={screenshotTab === 'ipad' ? 'screenshot-tab active' : 'screenshot-tab'}
                                onClick={() => setScreenshotTab('ipad')}
                            >iPad</span>
                            <span
                                className={screenshotTab === 'mac' ? 'screenshot-tab active' : 'screenshot-tab'}
                                onClick={() => setScreenshotTab('mac')}
                            >Mac</span>
                        </div>

                        {screenshotTab === 'iphone' && (
                            <div className="screenshots-grid">
                                <img src={iphone1} alt="VisiMap iPhone Screenshot 1" className="screenshot" />
                                <img src={iphone2} alt="VisiMap iPhone Screenshot 2" className="screenshot" />
                                <img src={iphone3} alt="VisiMap iPhone Screenshot 3" className="screenshot" />
                                <img src={iphone4} alt="VisiMap iPhone Screenshot 4" className="screenshot" />
                                <img src={iphone5} alt="VisiMap iPhone Screenshot 5" className="screenshot" />
                                <img src={iphone6} alt="VisiMap iPhone Screenshot 6" className="screenshot" />
                                <img src={iphone7} alt="VisiMap iPhone Screenshot 7" className="screenshot" />
                                <img src={iphone8} alt="VisiMap iPhone Screenshot 8" className="screenshot" />
                                <img src={iphone9} alt="VisiMap iPhone Screenshot 9" className="screenshot" />
                            </div>
                        )}

                        {screenshotTab === 'ipad' && (
                            <div className="screenshots-grid">
                                <img src={ipad1} alt="VisiMap iPad Screenshot 1" className="screenshot" />
                                <img src={ipad2} alt="VisiMap iPad Screenshot 2" className="screenshot" />
                                <img src={ipad3} alt="VisiMap iPad Screenshot 3" className="screenshot" />
                                <img src={ipad4} alt="VisiMap iPad Screenshot 4" className="screenshot" />
                                <img src={ipad5} alt="VisiMap iPad Screenshot 5" className="screenshot" />
                            </div>
                        )}

                        {screenshotTab === 'mac' && (
                            <div className="screenshots-grid">
                                <img src={mac1} alt="VisiMap Mac Screenshot 1" className="screenshot" />
                                <img src={mac2} alt="VisiMap Mac Screenshot 2" className="screenshot" />
                                <img src={mac3} alt="VisiMap Mac Screenshot 3" className="screenshot" />
                                <img src={mac4} alt="VisiMap Mac Screenshot 4" className="screenshot" />
                                <img src={mac5} alt="VisiMap Mac Screenshot 5" className="screenshot" />
                                <img src={mac6} alt="VisiMap Mac Screenshot 6" className="screenshot" />
                                <img src={mac7} alt="VisiMap Mac Screenshot 7" className="screenshot" />
                                <img src={mac13} alt="VisiMap Mac Screenshot 13" className="screenshot" />
                                <img src={mac14} alt="VisiMap Mac Screenshot 14" className="screenshot" />
                                <img src={mac15} alt="VisiMap Mac Screenshot 15" className="screenshot" />
                            </div>
                        )}
                    </section>
                )
            case 'terms':
                return (
                    <div className="legal-content" dangerouslySetInnerHTML={{ __html: termsContent }} />
                )
            case 'privacy':
                return (
                    <div className="legal-content" dangerouslySetInnerHTML={{ __html: privacyContent }} />
                )
            default:
                return null
        }
    }

    return (
        <div className="visimap-layout">
            <aside className="visimap-sidebar">
                <nav className="sidebar-nav">
                    <button
                        className={activeSection === 'overview' ? 'active' : ''}
                        onClick={() => handleSectionChange('overview')}
                    >
                        Overview
                    </button>
                    <button
                        className={activeSection === 'terms' ? 'active' : ''}
                        onClick={() => handleSectionChange('terms')}
                    >
                        Terms of Use
                    </button>
                    <button
                        className={activeSection === 'privacy' ? 'active' : ''}
                        onClick={() => handleSectionChange('privacy')}
                    >
                        Privacy Policy
                    </button>
                </nav>
            </aside>

            <main className="visimap-content">
                <div className="visimap-title">
                    <img src={visimapIcon} alt="VisiMap" className="visimap-icon" />
                    <h1>VisiMap</h1>
                </div>
                {renderContent()}
            </main>
        </div>
    )
}

export default VisiMap
